export const XmarkRegular = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M23.45,20.93c.71,.7,.71,1.83,0,2.54s-1.85,.7-2.55,0L12.02,14.57,3.08,23.47c-.71,.7-1.85,.7-2.55,0s-.71-1.83,0-2.54L9.47,12.03,.54,3.07C-.16,2.37-.16,1.23,.54,.53S2.39-.17,3.09,.53L12.03,9.5,20.97,.6c.71-.7,1.85-.7,2.55,0s.71,1.83,0,2.54L14.59,12.04l8.88,8.9h-.01Z" />
    </svg>
  );
};
